import styles from './DashboardGrid.module.css';

/** Primary module on the left, secondary modules stacked on the right (single column <=1024). */
const DashboardGrid = ({ fold, stack = [] }) => (
    <div className={`fold ${styles.fold}`}>
        {fold}
        <div className={`stack ${styles.stack}`}>{stack}</div>
    </div>
);

/** A secondary row under the fold. `even` makes two equal columns. */
export const Row = ({ even, children }) => (
    <div className={`${styles.row} ${even ? styles.even : ''}`}>{children}</div>
);

export default DashboardGrid;
